'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultComponents = exports.components = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
require('react');
var _containers = require('./containers');
var _indicators = require('./indicators');
var _Control = require('./Control');
var _Control2 = _interopRequireDefault(_Control);
var _Group = require('./Group');
var _Group2 = _interopRequireDefault(_Group);
var _Input = require('./Input');
var _Input2 = _interopRequireDefault(_Input);
var _Menu = require('./Menu');
var _Menu2 = _interopRequireDefault(_Menu);
var _MultiValue = require('./MultiValue');
var _MultiValue2 = _interopRequireDefault(_MultiValue);
var _Option = require('./Option');
var _Option2 = _interopRequireDefault(_Option);
var _Placeholder = require('./Placeholder');
var _Placeholder2 = _interopRequireDefault(_Placeholder);
var _SingleValue = require('./SingleValue');
var _SingleValue2 = _interopRequireDefault(_SingleValue);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var components = exports.components = {
  ClearIndicator: _indicators.ClearIndicator,
  Control: _Control2.default,
  DropdownIndicator: _indicators.DropdownIndicator,
  DownChevron: _indicators.DownChevron,
  CrossIcon: _indicators.CrossIcon,
  Group: _Group2.default,
  GroupHeading: _Group.GroupHeading,
  IndicatorsContainer: _containers.IndicatorsContainer,
  IndicatorSeparator: _indicators.IndicatorSeparator,
  Input: _Input2.default,
  LoadingIndicator: _indicators.LoadingIndicator,
  Menu: _Menu2.default,
  MenuList: _Menu.MenuList,
  MenuPortal: _Menu.MenuPortal,
  LoadingMessage: _Menu.LoadingMessage,
  NoOptionsMessage: _Menu.NoOptionsMessage,
  MultiValue: _MultiValue2.default,
  MultiValueContainer: _MultiValue.MultiValueContainer,
  MultiValueLabel: _MultiValue.MultiValueLabel,
  MultiValueRemove: _MultiValue.MultiValueRemove,
  Option: _Option2.default,
  Placeholder: _Placeholder2.default,
  SelectContainer: _containers.SelectContainer,
  SingleValue: _SingleValue2.default,
  ValueContainer: _containers.ValueContainer
};
var defaultComponents = exports.defaultComponents = function defaultComponents(props) {
  return _extends({}, components, props.components);
};